import React from 'react';

import * as analytics from '@adsk/acs-web-analytics';
import { LinkButton } from '@adsk/alloy-react-button';
import EmptyState from '@adsk/alloy-react-empty-state';

import { ANALYTICS_TYPES } from '../../analytics';
import i18n from '../../utils/i18n';

type AppContentErrorProps = {
  description?: string;
};

const AppContentError = ({ description }: AppContentErrorProps) => {
  return (
    <EmptyState
      title={i18n.t('ERROR_LOADING_APP')}
      description={description}
      illustrationType={
        EmptyState.ILLUSTRATION_TYPES.BUILDING_CONSTRUCTION_GREY
      }
      size={EmptyState.SIZES.LARGE}
      style={{
        height: '100%',
      }}
    >
      <LinkButton
        onClick={() => {
          analytics.track(ANALYTICS_TYPES.EXO_TOOL_INTERNAL_ERROR_TY_AGAIN);
          window.location.reload();
        }}
      >
        {i18n.t('TRY_AGAIN')}
      </LinkButton>
    </EmptyState>
  );
};

export default AppContentError;
